module.exports = __webpack_public_path__ + "img/pic-09.e395cda2.jpg";